var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[(_vm.authStateInitialised)?_c('router-view'):_c('q-inner-loading',{attrs:{"showing":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }